import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_property-counsel-1/artifacts/4d69y67q_IMG_0270.jpeg";

const footerLinks = {
  services: [
    { label: "Property Due Diligence", href: "/#services" },
    { label: "Title Verification", href: "/#services" },
    { label: "Acquisition Advisory", href: "/#services" },
    { label: "Diaspora Services", href: "/diaspora" },
  ],
  company: [
    { label: "About Us", href: "/#about" },
    { label: "Packages", href: "/packages" },
    { label: "Contact", href: "/#booking" },
  ],
  resources: [
    { label: "Property Buying Guide", href: "/guide/buying-property-nigeria" },
  ],
};

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0A0A0B] border-t border-[#D4AF37]/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4 md:mb-6">
              <img
                src={LOGO_URL}
                alt="4 ACES Attorneys"
                className="h-10 md:h-12 w-auto"
              />
              <div>
                <span className="font-['Playfair_Display'] text-base md:text-lg text-[#D4AF37] font-bold">
                  4 ACES
                </span>
                <span className="block text-[10px] md:text-xs text-white/60 tracking-[0.1em] md:tracking-[0.15em] uppercase">
                  Attorneys
                </span>
              </div>
            </Link>
            <p className="text-white/50 text-xs md:text-sm leading-relaxed">
              Private Property & Real Estate Law for Discerning Investors.
            </p>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 md:mb-6 text-xs md:text-sm tracking-wider uppercase">Services</h4>
            <ul className="space-y-2 md:space-y-3">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  {link.href.startsWith("/") && !link.href.includes("#") ? (
                    <Link
                      to={link.href}
                      className="text-white/50 text-xs md:text-sm hover:text-[#D4AF37] transition-colors"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      className="text-white/50 text-xs md:text-sm hover:text-[#D4AF37] transition-colors"
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-white font-semibold mb-4 md:mb-6 text-xs md:text-sm tracking-wider uppercase">Company</h4>
            <ul className="space-y-2 md:space-y-3">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  {link.href.startsWith("/") && !link.href.includes("#") ? (
                    <Link
                      to={link.href}
                      className="text-white/50 text-xs md:text-sm hover:text-[#D4AF37] transition-colors"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      className="text-white/50 text-xs md:text-sm hover:text-[#D4AF37] transition-colors"
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
            
            {/* Resources */}
            <h4 className="text-white font-semibold mt-6 mb-3 text-xs md:text-sm tracking-wider uppercase">Resources</h4>
            <ul className="space-y-2">
              {footerLinks.resources.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.href}
                    className="text-white/50 text-xs md:text-sm hover:text-[#D4AF37] transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold mb-4 md:mb-6 text-xs md:text-sm tracking-wider uppercase">Contact</h4>
            <ul className="space-y-2 md:space-y-3 text-xs md:text-sm">
              <li>
                <a
                  href="https://wa.me/2348032143826?text=Hello%204ACES%20Attorneys%2C%20I%20saw%20your%20website%20and%20would%20like%20to%20discuss%20a%20property%20transaction%20in%20Nigeria."
                  className="text-white/50 hover:text-[#25D366] transition-colors"
                >
                  +234 803 214 3826
                </a>
              </li>
              <li>
                <a
                  href="mailto:privateclients@4acesattorneys.com"
                  className="text-white/50 hover:text-[#D4AF37] transition-colors break-all"
                >
                  privateclients@4acesattorneys.com
                </a>
              </li>
              <li className="text-white/50">
                Guzape District, FCT Abuja
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 md:mt-16 pt-6 md:pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 md:gap-4">
          <p className="text-white/30 text-xs md:text-sm">
            © {currentYear} 4 ACES Attorneys. All rights reserved.
          </p>
          <p className="text-white/30 text-[10px] md:text-xs">
            Private Property & Real Estate Law Practice
          </p>
        </div>
      </div>
    </footer>
  );
};
